import React from 'react';

const UpcomingPreApproved = () => {
    const preApprovedData = [
        { id: 1, name: 'Sunita Mehta', vehicle: 'MH02DF9988', slot: 'P2-V020', time: 'Today, 02:30 PM', code: 'QR-90812' },
        { id: 2, name: 'Ravi Kumar', vehicle: 'MH12AB4567', slot: 'P2-V021', time: 'Today, 03:00 PM', code: 'QR-90813' },
        { id: 3, name: 'Ayesha Khan', vehicle: 'GJ05XY1234', slot: 'P3-PP012', time: 'Today, 04:15 PM', code: 'QR-90814' },
        { id: 4, name: 'John Doe', vehicle: 'DL09YZ8765', slot: 'P1-V002', time: 'Tomorrow, 09:00 AM', code: 'QR-90815' },
        { id: 5, name: 'Neha Gupta', vehicle: 'MH01PQ2345', slot: 'P1-V003', time: 'Tomorrow, 10:30 AM', code: 'QR-90816' },
    ];

    return (
        <div className="flex flex-col gap-4 mt-2">
            {preApprovedData.map((pass) => (
                <div key={pass.id} className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 hover:shadow-md transition-shadow">
                    <div>
                        <h3 className="text-xs font-bold text-gray-900 mb-1">{pass.name} (Pre-Approved Client)</h3>
                        <div className="flex items-center gap-2 text-[11px] text-gray-500">
                            <span>Vehicle: <span className="text-blue-600 font-medium">{pass.vehicle}</span></span>
                            <span className="text-gray-300">•</span>
                            <span>Reserved Slot: <span className="text-green-600 font-medium">{pass.slot}</span></span>
                        </div>
                    </div>
                    <div className="text-left sm:text-right">
                        <p className="text-xs font-bold text-blue-700 mb-0.5">{pass.time}</p>
                        <p className="text-[11px] text-gray-500">Pass Code: {pass.code}</p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default UpcomingPreApproved;
